import { List } from "@refinedev/antd";
import { useSearchParams } from "react-router";

import { LessonsTable } from "./lessons-table";

/** /lessons: everyone's lessons (permission `lessons.view`). */
export function LessonsPage() {
  // The dashboard links here with `?connection=problem`.
  const [params] = useSearchParams();
  return (
    <List title="Dersler">
      <LessonsTable
        endpoint="/api/office/lessons"
        showTutor
        showStudent
        initialConnection={params.get("connection") === "problem" ? "problem" : ""}
      />
    </List>
  );
}
